import React from "react";

import {
  PrimaryBlockType,
  primaryBlock,
  PrimaryBlockConfig,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  renderSecondaryBlock,
  getDefaultProps,
  MediaProp,
} from "@kameleon-core/lib";
import { Variants } from "@kameleon-util/global-theme";
import { Box } from "theme-ui";
import { LayoutProps } from "../types/prop-types";
import defaults from "../defaults.json";

export type ContentCollectionItemType = {
  tagline?: string;
  title?: string;
  description?: string;
  image?: MediaProp;
  link?: string;
  _parentBgColor?: string;
} & PrimaryBlockType<LayoutProps>;

/** ContentCollectionItem PrimaryCollection */
export const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.Small,
  tertiaryBlockSize: TertiaryBlockSize.Default,
  blockTheme: BlockTheme.light,
};

export const ContentCollectionItem = primaryBlock<ContentCollectionItemType>(
  blockConfig,
  ({
    SecondaryBlock,
    layoutProps,
    link,
    tagline,
    description,
    title,
    image,
    _parentBgColor,
  }: ContentCollectionItemType) => {
    const linkUrl = link || "";

    return (
      <Box sx={{ backgroundColor: _parentBgColor ?? "transparent" }}>
        <Box variant={layoutProps.itemBackground ? "cards.primary" : "box"}>
          <Variants.CardVertical
            image={image?.url}
            alt={image?.alt}
            link={link}
          >
            <Variants.CardVerticalContent
              hasCard={layoutProps.itemBackground}
              className="blog55_item-content"
            >
              {tagline && (
                <Variants.TagLine
                  sx={{ cursor: link ? "pointer" : "default" }}
                  className="blog63_category-link"
                >
                  <Variants.ParagraphSmall bold>
                    {tagline}
                  </Variants.ParagraphSmall>
                </Variants.TagLine>
              )}
              <Variants.LinkText
                sx={{ cursor: link ? "pointer" : "default" }}
                href={linkUrl}
                className="blog55_title-link"
              >
                <Variants.Heading
                  as="h3"
                  variant="h5"
                  className="heading-style-h5"
                >
                  {title}
                </Variants.Heading>
              </Variants.LinkText>
              <Box>{description}</Box>
              {renderSecondaryBlock(SecondaryBlock)}
            </Variants.CardVerticalContent>
          </Variants.CardVertical>
        </Box>
      </Box>
    );
  }
);

ContentCollectionItem.defaultProps = getDefaultProps<ContentCollectionItemType>(
  {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps.PrimaryBlocks[0],
  }
);
